import Vue from "vue";
import axios from "axios";


export const protecsureFunctions = new Vue({
  methods: {
    // async authenticate(method, data) {
    //   var resp = await this.postData("/crud/customer-lc-policy", {
    //     method,
    //     data
    //   });
    //   return resp.data;
    // }

    async acceptPSQuote(formModel) {
      console.log(formModel);
      var resp = await this.postData("/live/acceptPSQuote", formModel);
      return resp.data;
    },
    async acceptMotorQuote(formModel) {
      console.log(formModel);
      var resp = await this.postData("/live/acceptMotorQuote", formModel);
      return resp.data;
    },
    async getFormInitData() {
      var resp = await this.getData("/live/getFormInitData");
      return resp.data;
    },
    async requestQuote(body) {
      var resp = await this.postData("/live/requestQuote",body);
      return resp.data;
    },
    async updateQuote(body) {
      var resp = await this.postData("/live/updateQuote",body);
      return resp.data;
    },
    async updateQuotePublic(body) {
      var resp = await this.postDataPublic("/lookup/updatePSQuote",body);
      return resp.data;
    },
    async getUpdatedPeriodOfCover(dateString) {
      var resp = await this.getData("/live/getUpdatedPeriodOfCover?date=" + dateString);
      return resp.data;
    },
    async changeInceptionDate(dateString) {
      var resp = await this.postData("/live/requestQuote",body);
      return resp.data;
    },
    getData(url) {
      let config = {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token")
        }
      };

      return axios.get(process.env.VUE_APP_APIENDPOINT + url, config);
    },
    postData(url, body) {
      let config = {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token")
        }
      };

      return axios.post(process.env.VUE_APP_APIENDPOINT + url, body, config);
    },
    postDataPublic(url, body) {
      let config = {
        // headers: {
        //   Authorization: "Bearer " + sessionStorage.getItem("token")
        // }
      };

      return axios.post(process.env.VUE_APP_APIENDPOINT + url, body, config);
    },
  }

})